module.exports = __webpack_public_path__ + "img/arrow-h-medium.a2def110.png";